/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { shape, bool, number, object, string } = proptypes;
import { useStore } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { formatDate, formatInventory, showTodayOrTomorrow } from '../../../helper/utils';
import { getDefaultStoreHours, showBopisDate } from '../../../helper/timeZoneUtils';
import { IDS } from '../../../../automationTestIds';

const DefaultBOPIS = ({
  localStoreLocation, pickupStoreHours, isCartTiles, fallbackMode,
  configuratorHideQuantity, deliveryTimeline, fulfillment
}) => {
  let { storeHours } = useStore();
  if (!storeHours) {
    storeHours = getDefaultStoreHours();
  }
  const isInStock = localStoreLocation?.inventory?.isInStock || '';
  const quantity = localStoreLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);
  const pickupStoreHoursWithTZ = isCartTiles ? pickupStoreHours
    : { ...storeHours, ...pickupStoreHours };
  const isZeroInStock = isCartTiles && formattedInventoryQty <= 0;
  const isCartResilency = isCartTiles && (deliveryTimeline === null || deliveryTimeline === 'null')
    && localStoreLocation?.storeHours === null;

  const renderBopisTimeline = () => (deliveryTimeline ? (
    showTodayOrTomorrow(
      fulfillment?.deliveryDates?.endDate,
      true,
      deliveryTimeline,
      formatDate(fulfillment?.deliveryDates?.endDate)
    )
  ) : (
    showBopisDate(pickupStoreHoursWithTZ)
  ));

  const displayFFMRowDetails = () => {
    if (isInStock) {
      return (
        <>
          <Typography variant="body-base" weight="bold">
            <div
              className="sui-font-bold sui-min-h-[24px] sui-pb-1"
              data-testid="pickupTimeline"
              data-automation-id={IDS.ETA.pickupETA}
            >
              {isCartResilency ? <span>&nbsp;</span> : renderBopisTimeline()}
            </div>
          </Typography>
          <Typography variant="body-base">
            <div
              data-testid="fulfillment-qty-row"
              className="sui-min-h-[24px]"
              data-automation-id={IDS.QTY.pickupQty}
            >
              {(!fallbackMode && !configuratorHideQuantity) ? (
                <>
                  <span className="sui-text-success">{formattedInventoryQty}</span> in stock
                </>
              ) : (
                <span data-testid="empty-qty-row">&nbsp;</span>
              )}
            </div>
          </Typography>
        </>
      );
    }
    return (
      <>
        <div
          className="sui-font-bold sui-min-h-[24px] sui-pb-1"
          data-testid="pickupTimeline"
          data-automation-id={IDS.ETA.pickupETA}
        >&nbsp;
        </div>
        <div
          data-testid="fulfillment-qty-row"
          className="sui-min-h-[24px]"
          data-automation-id={IDS.QTY.pickupQty}
        >&nbsp;
        </div>
      </>
    );
  };

  return (
    <div>
      <TileHead title="Pickup" automationId={IDS.LABEL.pickupLabel} />
      <div className="">
        <div data-testid="ffm-details-row" className="sui-pt-2">
          {displayFFMRowDetails()}
        </div>
        <TileFooter className="sui-font-bold">
          <span className="sui-text-success">FREE</span>
        </TileFooter>

      </div>
    </div>

  );
};

DefaultBOPIS.propTypes = {
  localStoreLocation: shape({
    isAnchor: bool,
    inventory: shape({
      quantity: number,
      isInStock: bool,
      isLimitedQuantity: bool,
      isBackordered: bool
    })
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pickupStoreHours: object,
  isCartTiles: bool,
  fallbackMode: bool,
  configuratorHideQuantity: bool,
  deliveryTimeline: string,
  // eslint-disable-next-line react/forbid-prop-types
  fulfillment: object
};

DefaultBOPIS.defaultProps = {
  isCartTiles: false,
  pickupStoreHours: null,
  fallbackMode: false,
  configuratorHideQuantity: false,
  deliveryTimeline: null,
  fulfillment: {}
};

export { DefaultBOPIS };
